module.exports = __webpack_public_path__ + "40a519163be127fcf542bb140b7f9afd.MP3";